import type { TranslationMessages } from '../../types';

export const timesheet: TranslationMessages = {
  title: 'Hồ sơ điểm danh',
  subtitle: 'Xem và quản lý hồ sơ điểm danh và bảng chấm công của bạn',
  calendar_view: 'Chế độ xem lịch',
  list_view: 'Chế độ xem danh sách',
  total_hours: 'Tổng số giờ',
  overtime_hours: 'Giờ làm thêm',
  regular_hours: 'Giờ làm việc bình thường',
  export_pdf: 'Xuất PDF',
  export_excel: 'Xuất Excel',
  export_csv: 'Xuất CSV',
  date_range: 'Phạm vi ngày',
  start_date: 'Ngày bắt đầu',
  end_date: 'Ngày kết thúc',
  apply_filter: 'Áp dụng bộ lọc',
  clear_filter: 'Xóa bộ lọc',
  no_records: 'Không tìm thấy hồ sơ điểm danh',
  no_records_title: 'Không có hồ sơ điểm danh',
  no_records_description:
    'Không có hồ sơ điểm danh nào. Sử dụng tab Check-in/Check-out để tạo hồ sơ điểm danh đầu tiên của bạn.',
  no_filtered_records_description:
    'Không có hồ sơ nào khớp với bộ lọc hiện tại của bạn.',
  go_to_checkin: 'Đi đến Check-in/Check-out',
  filters_title: 'Bộ lọc',
  search_label: 'Tìm kiếm',
  search_placeholder: 'Tìm kiếm hồ sơ...',
  date_label: 'Ngày',
  status_label: 'Trạng thái',
  status_all: 'Tất cả',
  status_present: 'Có mặt',
  status_absent: 'Vắng mặt',
  stats_total_days: 'Tổng số ngày',
  stats_total_days_hint: '30 ngày qua',
  stats_present_days: 'Ngày có mặt',
  stats_present_days_hint: 'Số ngày đã tham dự',
  stats_absent_days: 'Ngày vắng mặt',
  stats_absent_days_hint: 'Số ngày đã bỏ lỡ',
  stats_total_hours: 'Tổng số giờ',
  stats_total_hours_hint: 'Số giờ đã làm việc',
  calendar_tab_label: 'Lịch',
  list_tab_label: 'Danh sách',
  view_day: 'Ngày',
  view_week: 'Tuần',
  view_month: 'Tháng',
  view_year: 'Năm',
  today_label: 'Hôm nay',
  this_week_label: 'Tuần này',
  this_month_label: 'Tháng này',
  this_year_label: 'Năm nay',
  legend_complete: 'Hoàn thành',
  legend_partial: 'Một phần',
  legend_absent: 'Vắng mặt',
  list_user_label: 'Người dùng',
};
